import { render } from "./agencyWrappers.vue?vue&type=template&id=01d3156a&scoped=true"
import script from "./agencyWrappers.vue?vue&type=script&lang=js"
export * from "./agencyWrappers.vue?vue&type=script&lang=js"

import "./agencyWrappers.vue?vue&type=style&index=0&id=01d3156a&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d3156a"]])

export default __exports__